import { apiFactory } from "@/api/factories/apiFactory";
class embeddedTokenService {
    _embeddedTokenApi = apiFactory.useEmbeddedTokenApi();
    _userApi = apiFactory.useUserApi();
    async findEmbeddedToken() {
        const user = await this._userApi.getUser();
        const response = await this._embeddedTokenApi.getEmbeddedToken(user.nexusUserId);
        return response;
    }
}
export default embeddedTokenService;
